import axiosInstance from "../../interceptor/intercetptor-inctence";


export const getTopSoldItems = (data) => {
	return axiosInstance.post(`pharma/max-sold`, data);
}

export const addSales = (data) => {
	return axiosInstance.post(`pharma/add-sales`, data);
}

export const salesList = (data) => {
	return axiosInstance.post(`pharma/get-sales`, data);
}

export const productSalesHistoryList = (data) => {
	return axiosInstance.post(`pharma/salesHistoryList`, data);
}

export const getSaleInfo = (data) => {
	return axiosInstance.post(`pharma/view-sales-details`, data);
}

export const getReturnInfo = (data) => {
	return axiosInstance.post(`pharma/getSalesDetails`, data);
}


export const getPresPreSignedUrl = (data) => {
	return axiosInstance.post(`pharma/getUploadFilepresignedURL`, data);
}

export const updateSalesItem = (data) => {
	return axiosInstance.post(`superadmin/updateItem`, data);
}

export const deleteSalesItem = (data) => {
	return axiosInstance.post(`superadmin/deleteItem`, data);
}

export const getItemBatch = (data) => {
	return axiosInstance.post(`pharma/get-batch`, data);
}

export const getTransactions = (data) => {
	return axiosInstance.post(`pharma/get-payments`, data);
}

export const getPatients = (data, isHospitalConnected) => {
	if (isHospitalConnected) {
		return axiosInstance.post(`healthcare_providers/search/patient`, data)
	} else {
		return axiosInstance.post(`pharma/masterPharmacyPatient`, data)
	}
}

export const getAllPatients = (data) => {
	return axiosInstance.post(`pharma/masterPharmacyPatient`, data)
}


// create standalone pharmacy patients (customer)
export const createPharmacyCustomer = (data) => {
	return axiosInstance.post(`pharma/createPharmacyPatient`, data)
}

export const getPatientPrescription = (data) => {
	return axiosInstance.post(`healthcare_providers/search/prescriptions`, data)
}

export const getSoldItems = (data) => {
	return axiosInstance.post(`pharma/get-sold-on-search`, data)
}

export const returnSalesAPI = (data) => {
	return axiosInstance.post(`pharma/return-sales`, data)
}

export const getWalletTransactions = (data) => {
	return axiosInstance.post(`pharma/get-wallet-transactions`, data)
}

export const walletWithdraw = (data) => {
	return axiosInstance.post(`pharma/walletWithdraw`, data)
}

export const walletTopUp = (data) => {
	return axiosInstance.post(`pharma/walletTopup`, data)
}

export const getCurrencyConversion = (data) => {
	return axiosInstance.post(`masters/currency_conversion`, data)
}

export const getTransactionDetails = (data) => {
	return axiosInstance.post(`pharma/get-transaction-details`, data)
}

export const getLabTestMaster = (data) => {
	return axiosInstance.post(`pharma/labTestMaster`, data)
}

export const getGeneralServiceMaster = (data) => {
	return axiosInstance.post(`pharma/generalServiceMaster`, data)
}